import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { Button } from '../../../components'
import { verificarExisteEmpresaPdca } from '../base/redux/pdcaBaseActions'
import apiPdca from '../../../helpers/apiPdca'
import './integrationsClickupCallback.scss'

export default () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { idProjetos } = useParams()

  const { sistema } = useSelector(state => state.layoutState)
  const nls = require(`./nls/${sistema.idioma}.json`)

  const [status, setStatus] = useState('loading')
  const [debugError, setDebugError] = useState('')

  useEffect(() => {
    const processar = async () => {
      try {
        const params = new URLSearchParams(window.location.search)
        const state = params.get('state')
        const code = params.get('code')

        if (!state || !code) {
          throw new Error('State ou code não encontrados no retorno do ClickUp.')
        }

        await apiPdca.post(`/projetos/${idProjetos}/integracao/clickup/oauth/exchange`, {
          state,
          code
        })

        setStatus('success')
      } catch (error) {
        const mensagemTecnica =
          error?.response?.data?.complemento ||
          error?.response?.data?.title ||
          error?.message ||
          'Erro desconhecido ao processar callback do ClickUp.'

        setDebugError(mensagemTecnica)
        setStatus('error')
      }
    }

    processar()
  }, [idProjetos])

  const irParaIntegrationsComContexto = async () => {
    const result = await dispatch(verificarExisteEmpresaPdca(idProjetos))

    if (result?.ok) {
      history.push(`/myprojects/${idProjetos}/pdca/integrations`)
      return
    }

    history.push(`/myprojects/${idProjetos}/pdca`)
  }

  const handleVoltar = () => {
    irParaIntegrationsComContexto()
  }

  return (
    <div className='box-pdca-clickup-callback-page'>
      <div className='box-pdca-clickup-callback'>
        {status === 'loading' && (
          <div className='box-pdca-clickup-callback-loading'>
            {nls.loading || 'Conectando com ClickUp...'}
          </div>
        )}

        {status === 'success' && (
          <div className='box-pdca-clickup-callback-success'>
            <img src='/pdcaokacao.svg' alt='sucesso' />
            <div className='box-pdca-clickup-callback-text'>
              {nls.success || 'Integração com ClickUp realizada com sucesso'}
            </div>

            <div className='box-pdca-clickup-callback-actions'>
              <Button color='primary' onClick={handleVoltar}>
                {nls.back || 'Voltar para Integração'}
              </Button>
            </div>
          </div>
        )}

        {status === 'error' && (
          <div className='box-pdca-clickup-callback-error'>
            <img src='/pdcaproblemaacao.svg' alt='erro' />
            <div className='box-pdca-clickup-callback-text'>
              {nls.error || 'Erro ao conectar com ClickUp'}
            </div>

            {!!debugError && (
              <div className='box-pdca-clickup-callback-debug'>
                {debugError}
              </div>
            )}

            <div className='box-pdca-clickup-callback-actions'>
              <Button color='default' onClick={handleVoltar}>
                {nls.back || 'Voltar para Integração'}
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}